<template>
  <div class="pagoda-left-right-layout">
    <!-- 顶部菜单栏 -->
    <div class="pagoda-left-right-layout__flex">
      <div class="pagoda-left-right-layout__back-text" @click="handleBack"><span>{{backText}}</span></div>
      <!-- 页面标题 -->
      <div class="pagoda-left-right-layout__title">{{title}}</div>
      <!-- 按钮区 -->
      <div class="pagoda-left-right-layout__btn-groups">
        <slot name="operation"></slot>
      </div>
    </div>
    <!-- 顶部栏下方插槽 -->
    <div class="pagoda-left-right-layout__before-content" v-if="$slots['before-content']">
      <slot name="before-content"></slot>
    </div>
    <!-- 主内容区 -->
    <div class="pagoda-left-right-layout__content">
      <!-- 左边内容区 -->
      <div class="content-left">
        <div class="part-top"><slot name="tabs"></slot></div>
        <div class="content-cont"><slot name="content"></slot></div>
      </div>

      <div class="content-border"></div>
      <!-- 右边信息栏 -->
      <div class="content-right">
        <div class="content-right__top" :class="{'top-border': hasBorder}">
          <div class="top-title">{{subTitle}}</div>
          <slot name="edit"></slot>
        </div>
        <div class="content-right__form" ref="contentForm">
          <slot name="content-form"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'LeftRightLayout',
  props: {
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    backText: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      hasBorder: false
    }
  },
  methods: {
    handleBack() {
      this.$emit('back')
    }
  },
  mounted () {
    this.contentForm = this.$refs.contentForm
    this.contentForm.addEventListener('scroll', () => {
      if (this.subTitle) {
        if (this.$refs.contentForm.scrollTop !== 0) {
          this.hasBorder = true
        } else {
          this.hasBorder = false
        }
      }
    }, false)
  }
}
</script>
